<template>
  <aside class="right-sidebar">
    <!-- <div class="sidebar-title">导航</div> -->
    <div class="project-list">
      <div
        v-for="item in filteredNavItems"
        :key="item.id"
        :class="['project-item', { active: item.id === selectedId, disabled: item.disabled }]"
        @click="!item.disabled && scrollToSection(item.id)"
      >
        <!-- <el-icon><Document /></el-icon> -->
        <span>{{ item.title }}</span>
      </div>
      

    </div>
  </aside>
</template>

<script>
import { computed, ref, watch } from 'vue';
import { Document } from '@element-plus/icons-vue';

export default {
  name: 'RightSidebarComponent',
  components: { Document },
  props: {
    showSynopsis: { type: Boolean, default: true },
    showOutline: { type: Boolean, default: false },
    showScript: { type: Boolean, default: false },
    activeId: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    hasOutlineData: { type: Boolean, default: false }
  },
  setup(props, { emit }) {
    const navItems = computed(() => [
      { id: 'synopsis', title: '故事梗概与人物小传', show: props.showSynopsis, disabled: props.disabled },
      { id: 'outline', title: '分集大纲', show: props.showOutline, disabled: props.disabled || !props.hasOutlineData },
      { id: 'script', title: '详细剧本', show: props.showScript, disabled: props.disabled || !props.hasOutlineData }
    ]);
    const filteredNavItems = computed(() => navItems.value.filter(item => item.show));

    const scrollToSection = (id) => {
      emit('navigate', id);
    };

    return { 
      filteredNavItems, 
      scrollToSection, 
      selectedId: computed(() => props.activeId) 
    };
  }
};
</script>

<style scoped>
.right-sidebar {
  width: 220px;
  background: #fff;
  border-left: 1px solid #ececec;
  padding: 32px 0 0 0;
  display: flex;
  flex-direction: column;
  min-width: 140px;
  position: sticky;
  top: 0;
  height: 100vh;
}
.sidebar-title {
  font-size: 18px;
  font-weight: bold;
  color: #409eff;
  margin-bottom: 24px;
  text-align: center;
}
.project-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 0 24px;
}
.project-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 15px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 8px;
  transition: background 0.2s, color 0.2s;
}
.project-item.active, .project-item:hover {
  background: #f0f7ff;
  color: #409eff;
}
.project-item.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
.project-item.disabled:hover {
  background: transparent;
  color: inherit;
}
/* 响应式：右侧边栏在中小屏隐藏 */
@media (max-width: 1200px) {
  .right-sidebar { display: none; }
}
</style>